import { Box, css } from 'theme-ui';
import styled from '../../lib/transient-styled';
import headerPack from '../../shared-styled/typography/headers';
import pxToRem from '../../utils/pixelsToRem';
import Image from '../Image';

export const ContentBlock = styled(Box)(
  css({
    lineHeight: pxToRem(28),
    letterSpacing: '0.01em',
    mb: '40px',

    '& p': {
      mb: '28px',

      '&:last-child': {
        mb: 0,
      },
    },

    '& a': {
      color: 'secondaryGreen',
      textDecoration: 'none',
      '@media print': {
        textDecoration: 'underline !important',
        color: '#1A3A35 !important',
      },

      '&:hover': {
        textDecoration: 'underline',
      },
    },

    ...headerPack,
  }),
);

export const ContentTitle = styled.p(
  css({
    fontWeight: '600',
    fontSize: pxToRem(24),
    lineHeight: pxToRem(28),
    letterSpacing: '0.01em',
    mb: '32px',
  }),
  ({ $isLink }) =>
    css({
      cursor: $isLink ? 'pointer' : 'default',
      color: $isLink ? 'secondaryGreen' : 'text',

      '&:hover': {
        textDecoration: $isLink && 'underline',
      },
    }),
);

export const ContentImage = styled.img(
  css({
    width: ['100%', '100%', '40%'],
    padding: '0 32px 32px 0',
    cssFloat: 'left',
  }),
);
